import { put, call } from 'redux-saga/effects';
import ApiInstance from '../../helpers/apiInstance';
import { sendRequest } from '../../helpers/saga';
import actions from './actions';
import { IFeatureFlagsApiResponse } from './types';

const api = new ApiInstance('feature_flags');

function* fetchFeatureFlags() {
  const result: IFeatureFlagsApiResponse = yield call(sendRequest, api.get, {}, actions.FETCH_FEATURE_FLAGS_ERROR);

  if (result?.status === 200 && result.data?.feature_flags) {
    yield put(actions.fetchFeatureFlagsSuccess(result.data.feature_flags));
  } else {
    yield put(actions.fetchFeatureFlagsError());
  }
}

export { fetchFeatureFlags };
